import { h } from '../dom';
import { sound } from '../sound';

/** Tlačítko 🔊/🔇 – přepíná zvuk (nastavení se pamatuje v prohlížeči). */
export function soundButton(className: string, cleanups?: (() => void)[]): HTMLButtonElement {
  const btn = h('button', { class: className, type: 'button', onclick: () => sound.toggle() }) as HTMLButtonElement;
  const render = (on: boolean) => {
    btn.textContent = on ? '🔊' : '🔇';
    btn.title = on ? 'Vypnout zvuk' : 'Zapnout zvuk';
    btn.setAttribute('aria-label', btn.title);
    btn.setAttribute('aria-pressed', String(on));
  };
  render(sound.enabled);
  const off = sound.onChange(render);
  cleanups?.push(off);
  return btn;
}
